@if (visible()) {
  <div
    class="consent-banner"
    *transloco="let t"
    role="dialog"
    aria-modal="false"
    [attr.aria-label]="t('consent.ariaLabel')"
  >
    <div class="consent-banner__inner">
      <div class="consent-banner__text">
        <h2 class="consent-banner__title">{{ t('consent.title') }}</h2>
        <p class="consent-banner__desc">
          {{ t('consent.description', { brand: displayName() || t('consent.fallbackBrand') }) }}
        </p>
      </div>

      @if (showSettings()) {
        <div class="consent-banner__categories">
          <!-- Always-on: necessary / functional -->
          <div class="consent-category consent-category--locked">
            <div class="consent-category__head">
              <span class="consent-category__name">{{ t('consent.category.necessary.name') }}</span>
              <span class="consent-category__always">{{ t('consent.alwaysActive') }}</span>
            </div>
            <p class="consent-category__desc">{{ t('consent.category.necessary.desc') }}</p>
          </div>

          <!-- Analytics -->
          <div class="consent-category">
            <div class="consent-category__head">
              <label class="consent-category__name" [attr.for]="'consent-analytics'">
                {{ t('consent.category.analytics.name') }}
              </label>
              <p-toggleswitch
                inputId="consent-analytics"
                [ngModel]="analyticsSelected()"
                (ngModelChange)="analyticsSelected.set($event)"
                [ariaLabel]="t('consent.category.analytics.name')"
              />
            </div>
            <p class="consent-category__desc">{{ t('consent.category.analytics.desc') }}</p>
          </div>

          <!-- Marketing -->
          <div class="consent-category">
            <div class="consent-category__head">
              <label class="consent-category__name" [attr.for]="'consent-marketing'">
                {{ t('consent.category.marketing.name') }}
              </label>
              <p-toggleswitch
                inputId="consent-marketing"
                [ngModel]="marketingSelected()"
                (ngModelChange)="marketingSelected.set($event)"
                [ariaLabel]="t('consent.category.marketing.name')"
              />
            </div>
            <p class="consent-category__desc">{{ t('consent.category.marketing.desc') }}</p>
          </div>
        </div>
      }

      <div class="consent-banner__actions">
        @if (showSettings()) {
          <p-button
            severity="secondary"
            [outlined]="true"
            [label]="t('consent.savePreferences')"
            (onClick)="savePreferences()"
          />
        } @else {
          <p-button
            severity="secondary"
            [text]="true"
            [label]="t('consent.settings')"
            (onClick)="toggleSettings()"
          />
        }
        <p-button
          severity="secondary"
          [outlined]="true"
          [label]="t('consent.rejectNonEssential')"
          (onClick)="rejectNonEssential()"
        />
        <p-button
          [label]="t('consent.acceptAll')"
          (onClick)="acceptAll()"
        />
      </div>
    </div>
  </div>
}
